export default "__VITE_ASSET__CDA8pYBJ__"